import { render, staticRenderFns } from "./SalesByDate.vue?vue&type=template&id=f36a3b70&"
import script from "./SalesByDate.vue?vue&type=script&lang=js&"
export * from "./SalesByDate.vue?vue&type=script&lang=js&"
import style0 from "./SalesByDate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports